<template>
	<div class="home" ref="home">
		<div class="right-tag-list-wrap">
			<div class="right-tag-list">
				<div class="tag-list" @click="gradeScore" :class="{ 'btn-active': markBoardState }" v-if="handleMeans === 'single'">
					打 分
				</div>
				<div class="tag-list" @click="patchScore" :class="{ 'btn-active': patchBoardState }" v-if="handleMeans === 'multiple'">
					批 量 阅 卷
				</div>
				<div class="tag-list" id="" v-if="query.type === '3'" @click="finalHistoryRecord" :class="{ 'btn-active': finalHistoryBoardState }">
					{{ `阅 卷 记 录` }}
				</div>
				<div class="tag-list" v-else @click="historyScore" :class="{ 'btn-active': historyBoardState }">
					{{ `阅 卷 记 录` }}
				</div>
			</div>
			<guide
				:class="{ 'score-btn-guide': guideStep === 4, 'history-score-btn-guide': guideStep === 10 }"
				v-if="guideStep === 4 || guideStep === 10"
				:title="guideStepVal[guideStep].title"
				:distribute="guideStepVal[guideStep].distribute"
				:isTopArr="false"
			/>
		</div>
		<div class="progress" id="progress-line-wrap" v-show="!isFullNav">
			<progress-line />
		</div>
		<div class="content">
			<mark-content v-show="handleMeans === 'single'" />
			<patch-content v-show="handleMeans === 'multiple'" />
		</div>
		<mark-score-board v-show="markBoardState" />
		<answer-board v-show="answerBoardState" />
		<patchScoreBoard v-show="patchBoardState" />
		<history-record-board-final v-if="query.type === '3' && finalHistoryBoardState"></history-record-board-final>
		<history-record-board :guideStepVal="guideStep" ref="historyRecord" v-if="historyBoardState && query.type !== '3'" />
		<score-board v-show="scoreBoardState" />
		<fast-score-board v-show="fastScoreBoardState" v-model="fastScoreBoardState" />
		<page-preview v-if="originColumnBoardState" :basicInfo="basicInfo"></page-preview>
		<div class="is_show_nav">
			<i class="iconfont iconbangzhu1" @click="showGuide"></i>
			<i
				class="iconfont"
				:title="isFullNav ? '显示导航' : '隐藏导航'"
				:class="isFullNav ? 'iconhidden-navigation' : 'icondisplay-navigation'"
				@click="isShowNav"
			></i>
			<i class="iconfont" :title="isFullScreen ? '退出全屏' : '全屏'" :class="isFullScreen ? 'iconziyuan2' : 'iconziyuan1'" @click="operateScreen"></i>
		</div>

		<!--联考关闭 批量阅卷-->
		<div v-show="false">
			<div class="sel-means" @click="choseMeans">
				<i class="iconfont iconjiantou-left-copy"></i>
			</div>
		</div>
		<div>
			<el-drawer class="sel-el-drawer" title="请选择阅卷方式" size="12%" :visible.sync="drawerState" :direction="drawerDirection">
				<el-radio-group v-model="handleMeans" @change="radioChange">
					<el-radio label="single" border size="medium">打 分 阅 卷</el-radio>
					<el-radio label="multiple" border size="medium">批 量 阅 卷</el-radio>
				</el-radio-group>
			</el-drawer>
		</div>
		<div class="guide-state" v-if="getIsNewPerson"></div>
	</div>
</template>
<script>
import { mapMutations, mapActions, mapGetters } from 'vuex'
import cookies from '@/utils/cookie'
import guideMixin from './utils/guide-mixin'
export default {
	name: 'Home',
	components: {
		markScoreBoard: () => import('./component/mark-score-board'),
		answerBoard: () => import('./component/answer-board'),
		patchScoreBoard: () => import('./component/patch-score-board'),
		historyRecordBoardFinal: () => import('./component/history-record-board-final'),
		historyRecordBoard: () => import('./component/history-record-board'),
		scoreBoard: () => import('./component/score-board'),
		fastScoreBoard: () => import('./component/fast-score-board'),
		markContent: () => import('./component/mark-content'),
		patchContent: () => import('./component/patch-content'),
		progressLine: () => import('./component/progress-line'),
		pagePreview: () => import('../../components/page-preview'),
		guide: () => import('./component/guide')
	},
	mixins: [guideMixin],
	computed: mapGetters('examination/exam', ['getIsNewPerson']),
	data() {
		return {
			//打分总面板
			markBoardState: true,
			//答案 面板状态
			answerBoardState: false,
			//历史面板状态
			historyBoardState: false,
			// 终评面板状态
			finalHistoryBoardState: true,
			//no use
			copyScoreBoardState: false,
			//打分版打分状态
			scoreBoardState: false,
			//no use
			copyFastScoreBoardState: false,
			//快捷打分面板状态
			fastScoreBoardState: false,
			//原卷预览状态
			originColumnBoardState: false,
			//基本信息
			basicInfo: {},
			//no use
			sumHistory: 0,
			//导航栏状态
			isFullNav: false,
			//是否全屏
			isFullScreen: false,
			//拖拽位置
			dragStartX: 10,
			dragStartY: 40,
			//批量阅卷 抽屉状态
			drawerState: false,
			//批量阅卷 抽屉方向
			drawerDirection: 'rtl',
			query: this.$route.query,
			//批量打分  选择方式
			handleMeans: 'single',
			//批量阅卷  状态
			patchBoardState: false,
			//引导
			guideStepVal: {
				4: {
					title: '打分',
					distribute: '点击打分按钮， 出现打分面板'
				},
				10: {
					title: '阅卷记录',
					distribute: '点击按钮，出现阅卷记录面板'
				}
			}
		}
	},
	beforeCreate() {
		const query = this.$route.query
		cookies.set('token', query.token)
		cookies.set('uuid', 'userId-' + query.userId)
	},
	async created() {
		this.del({ dbName: 'database', path: 'nextData', delKey: '', user: true })
		this.watchCompEmit()
		const query = this.$route.query
		const type = {
			'0': '初评阅卷-云阅卷',
			'2': '疑难卷阅卷-云阅卷',
			'3': '终评阅卷-云阅卷'
		}
		document.title = type[query.type]
	},
	mounted() {
		// this.$screenRation()
	},
	beforeDestroy() {
		cookies.remove('token')
		localStorage.removeItem('userId')
		localStorage.removeItem('finalCanNotExam')
		localStorage.removeItem('historyBoardState')
	},
	methods: {
		...mapActions('examination/databases', ['get', 'del']),
		...mapMutations('examination/exam', ['setIsNewPerson']),
		// 引导页
		watchCompEmit() {
			this.eventBus.$on('historyBoardState', cb => {
				this.historyBoardState = cb
			})
			this.eventBus.$on('finalHistoryBoardState', cb => {
				this.finalHistoryBoardState = cb
			})
			this.eventBus.$on('markBoardState', cb => (this.markBoardState = cb))
			this.eventBus.$on('answerChange', cb => (this.answerBoardState = cb))
			this.eventBus.$on('patchBoardState', cb => (this.patchBoardState = cb))
			this.eventBus.$on('scoreBoardState', cb => (this.scoreBoardState = cb))
			this.eventBus.$on('fastScoreBoardState', cb => (this.fastScoreBoardState = cb))
			this.eventBus.$on('originColumnBoardState', cb => (this.originColumnBoardState = cb))
			this.eventBus.$on('guideStepPatchScore', () => {
				this.drawerState = false
				this.radioChange('multiple')
			})
			this.eventBus.$on('guideStepHistoryScore', cb => {
				this.historyBoardState = cb
				this.historyScore()
			})
			this.eventBus.$on('guideStepScoreBoard', cb => {
				if (!cb) this.gradeScore()
			})
			this.eventBus.$on('historyToScoreSingle', () => {
				this.patchBoardState = false
				this.handleMeans = 'single'
			})
			this.eventBus.$on('sumHistory', cb => (this.sumHistory = cb))
			this.eventBus.$on('isScoreBoardState', cb => {
				this.scoreBoardState = cb
				this.copyScoreBoardState = cb
			})
			this.eventBus.$on('isFastScoreState', cb => {
				this.fastScoreBoardState = cb
				this.copyFastScoreBoardState = cb
			})
			this.eventBus.$on('basicInformation', cb => {
				this.basicInfo = cb
				this.sumHistory = cb.markingedSum
			})
		},
		// 终评打分
		finalHistoryRecord() {
			this.finalHistoryBoardState = !this.finalHistoryBoardState
			this.eventBus.$emit('finalHistoryBoardState', this.finalHistoryBoardState)
			if (this.finalHistoryBoardState) {
				window.location.reload()
			}
		},
		//打分 btn
		gradeScore() {
			this.eventBus.$emit('markBoardState', !this.markBoardState)
			this.eventBus.$emit('isDisplayMarkScoreBoard', true)
			this.eventBus.$emit('scoreBoardState', false)
			this.eventBus.$emit('isScoreBoardState', false)
			this.eventBus.$emit('fastScoreBoardState', false)
			this.eventBus.$emit('isFastScoreState', false)
			if (this.markBoardState) {
				this.scoreBoardState = this.copyScoreBoardState
				this.fastScoreBoardState = this.copyFastScoreBoardState
			}
		},
		// 批量打分
		patchScore() {
			this.eventBus.$emit('patchBoardState', !this.patchBoardState)
			this.eventBus.$emit('scoreBoardState', false)
			this.eventBus.$emit('isScoreBoardState', false)
			this.eventBus.$emit('fastScoreBoardState', false)
			this.eventBus.$emit('isFastScoreState', false)
		},
		//阅卷记录 btn click
		historyScore() {
			this.eventBus.$emit('historyBoardState', !this.historyBoardState)
			localStorage.removeItem('finalCanNotExam')
		},
		//	 是否显示导航
		isShowNav() {
			this.isFullNav = !this.isFullNav
			this.eventBus.$emit('isFullNav', this.isFullNav)
		},
		// 全屏
		operateScreen() {
			this.$fullscreen.toggle(this.$refs['home'], {
				wrap: true,
				callback: this.fullscreenChange
			})
		},
		fullscreenChange() {
			this.isFullScreen = !this.isFullScreen
		},
		// 引导页面
		showGuide() {
			this.setIsNewPerson(true)
		},
		// 选择 打分方式
		choseMeans() {
			this.drawerState = true
		},
		// 确定打分方式
		radioChange(val) {
			this.drawerState = false
			this.handleMeans = val
			let markFlag = false,
				patchFlag = false
			if (val === 'single') {
				markFlag = true
			} else if (val === 'multiple') {
				patchFlag = true
				this.eventBus.$emit('setPatchNum', 1)
			}
			this.eventBus.$emit('markBoardState', markFlag)
			this.eventBus.$emit('patchBoardState', patchFlag)
		}
	}
}
</script>
<style lang="less" scoped>
.home {
	width: 100%;
	height: 100%;
	overflow: hidden;
	.content {
		width: 100%;
		height: 100%;
	}
	.right-tag-list {
		position: absolute;
		right: 0;
		top: 50%;
		transform: translateY(-50%);
		z-index: 19;
		.tag-list {
			width: 46px;
			text-align: center;
			writing-mode: vertical-lr;
			box-shadow: 0 0 20px 0 rgba(0, 0, 0, 0.05);
			border-radius: 20px 0 0 20px;
			padding: 40px 0 40px 10px;
			font-size: 24px;
			background: #009688;
			color: white;
			box-sizing: border-box;
			cursor: pointer;
			margin-top: 20px;
			@media screen and (max-width: 1920px) {
				width: 35px;
				font-size: 18px;
			}
		}
		.btn-active {
			background: #1d635c;
		}
	}
	.progress {
		display: flex;
		justify-content: flex-start;
		align-items: center;
		position: relative;
		z-index: 5;
	}
	.is_show_nav {
		position: fixed;
		top: 3px;
		right: 3px;
		display: flex;
		justify-content: flex-end;
		align-items: center;
		z-index: 5;
		.iconfont {
			margin-right: 5px;
			font-size: 26px;
			color: rgba(32, 30, 30, 0.8);
		}
		&:hover {
			cursor: pointer;
		}
		.iconbangzhu1 {
			font-size: 24px;
		}
	}
	.full-screen {
		width: 50px;
		height: 50px;
		display: flex;
		justify-content: center;
		align-items: center;
		position: fixed;
		top: 40px;
		right: 0;
		background: rgba(0, 0, 0, 0.8);
		border-radius: 50%;
		z-index: 10;
		@media screen and (max-width: 1920px) {
			width: 30px;
			height: 30px;
			.iconfont {
				font-size: 18px;
			}
		}
		&:hover {
			cursor: pointer;
		}
		.iconfont {
			font-size: 26px;
			color: white;
		}
	}
	.sel-means {
		position: fixed;
		right: 0;
		bottom: 30px;
		border-bottom-left-radius: 20px;
		border-top-left-radius: 20px;
		background: #009688;
		padding: 5px 0 5px 10px;
		.iconjiantou-left-copy {
			font-size: 30px;
			color: #fff;
		}
	}
	/deep/.el-drawer__body {
		padding: 30px;
		box-sizing: border-box;
	}
	/deep/.el-radio {
		display: block;
		margin: 0;
		margin-left: 0 !important;
		margin-bottom: 30px;
		padding: 10px 50px 0 20px;
	}
	/deep/.driver-next-btn {
		color: red;
	}
	/deep/.guide-operate-area {
		font-size: 15px;
	}
	.guide-mark-board {
		position: absolute;
		top: 100px;
		right: 100px;
		background: red;
	}
	.guide-state {
		position: absolute;
		top: 0;
		left: 0;
		width: 100%;
		height: 100%;
		z-index: 19;
		background: black;
		opacity: 0.3;
		pointer-events: none;
	}
}
</style>
